import React from "react"
import { StaticQuery, graphql } from "gatsby"

import "./topMenu.scss"

const renderLink = linkItem => {

  if (linkItem.target == '_blank' || linkItem.target == null ) {
    return (
      <a
        target={linkItem.target == '_blank' ? "_blank" : "_self"}
        rel="noreferrer noopener"
        href={linkItem.url}
        title={linkItem.label}>
        {linkItem.label}
      </a>
    )
  } else {
    return (
      <a href={linkItem.url} title={linkItem.label}>
        {linkItem.label}
      </a>
    )
  }
}

const navStyle = {
  background: '#000000',
  padding: 0,
  textAlign: 'right'
}

const menuStyle ={
  margin: 0,
  whiteSpace: 'nowrap'
}

const menuItemStyle = {
  display: 'inline-block'
}

const TopMenu = () => {
  return (
    <nav className="top-menu" style={navStyle}>
      <div className="container">
        <StaticQuery
          query={graphql`
            query TopMenuQuery {
              allWpMenu(filter: { slug: { eq: "top-navigation" } }) {
                edges {
                  node {
                    id
                    menuItems {
                      nodes {
                        url
                        label
                        target
                        id
                        cssClasses
                      }
                    }
                    slug
                    name
                  }
                }
              }
            }
          `}
          render={data => {
            return (
              <ul
                name={data.allWpMenu.edges[0].node.name}
                className={`menu menu-${data.allWpMenu.edges[0].node.slug}`}
                style={menuStyle}
              >
                {data.allWpMenu.edges[0].node.menuItems.nodes.map(menuItem => {
                  return (
                    <li
                      key={menuItem.id}
                      className={`post post-id-${
                        menuItem.id
                      } ${menuItem.cssClasses.join(" ")}`}
                      style={menuItemStyle}
                    >
                      {renderLink(menuItem)}
                    </li>
                  )
                })}
                {
                  // TODO: Login button
                  /* <li>
                  <button href="#">
                    Log In
                    <ProfileIcon />
                  </button>
                  </li> */
                }
              </ul>
            )
          }}
        />
      </div>
    </nav>
  )
}

export default TopMenu
